import { render, staticRenderFns } from "./ProductIncipitInfo.vue?vue&type=template&id=99d02d18"
import script from "./ProductIncipitInfo.vue?vue&type=script&lang=ts"
export * from "./ProductIncipitInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProductIncipitInfo.vue?vue&type=style&index=0&id=99d02d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports